import React, { useMemo } from 'react'

// api
import { useUsersQuery } from '../../../requests/users'

// utils
import { formatTimeAgo } from '../../../utils/formatTimeAgo'
import { useAuth } from '../../../contexts/useAuthUser'

// components
import { Skeleton } from '../../../components/Skeleton'
import { ListUserInboxes } from './ListUserInboxes'

export const UsersTable: React.FC = () => {
  const { authUser } = useAuth()
  const { data: users = [], isLoading: loading } = useUsersQuery({
    enabled: !!authUser?.superAdmin
  })

  // Sort users by recently active
  const sortedUsers = useMemo(() => {
    return [...users].sort((a, b) => {
      // recently active users at top
      if (!a.lastActivity) {
        return 1
      }

      if (!b.lastActivity) {
        return -1
      }

      return new Date(b.lastActivity).getTime() - new Date(a.lastActivity).getTime()
    })
  }, [users])

  return (
    <table>
      <thead>
        <tr>
          <th>Email</th>
          <th>Joined</th>
          <th>Folders</th>
          <th>Last Online</th>
        </tr>
      </thead>
      <tbody>
        {
          loading ? (
            Array.from({ length: 5 }).map((_, index) => (
              <tr key={`skeleton-${index}`}>
                <td>
                  <Skeleton width={200} />
                </td>
                <td>
                  <Skeleton width={150} />
                </td>
                <td>
                  <Skeleton width={100} />
                </td>
                <td>
                  <Skeleton width={120} />
                </td>
              </tr>
            ))
          ) : (
            sortedUsers.map((user) => (
              <tr key={user._id}>
                <td>{user.email}</td>
                <td>
                  {new Date(user.createdAt).toLocaleString()}
                </td>
                <td>
                  <ListUserInboxes userId={user._id} />
                </td>
                <td>
                  { formatTimeAgo(user.lastActivity) }
                </td>
              </tr>
            ))
          )
        }
      </tbody>
    </table>
  )
}
